import { useCallback, useState } from 'react';

export const useForceRerender = () => {
  const [editorKey, setEditorKey] = useState(0);

  const forceRerender = useCallback(() => {
    setEditorKey((prevKey) => prevKey + 1);
  }, []);

  return { editorKey, forceRerender };
};
